import styled from 'styled-components';

import { colors } from 'constants/colors';

import { ColumnPhotosSection } from './photos/ColumnPhotosSection';
import { SetupInstructionType, FreefoodSetupFragmentFragment } from 'data/__generated__';
import { isPhotosInstruction } from 'pages/SiteSetups/utils/typePredicates';
import { SETUP_INSTRUCTION_TYPE_LABELS } from 'pages/SiteSetups/constants/types';

export const FreefoodDetails = ({ freefoodSetup }: { freefoodSetup: FreefoodSetupFragmentFragment }) => {
    const photosInstruction = freefoodSetup.instructions.find(({ type }) => type === SetupInstructionType.Photos);

    return (
        <Container>
            {photosInstruction && isPhotosInstruction(photosInstruction) ? (
                <ColumnPhotosSection
                    instruction={photosInstruction}
                    title={SETUP_INSTRUCTION_TYPE_LABELS[photosInstruction.type]}
                />
            ) : null}
        </Container>
    );
};

const Container = styled.div`
    border: 1px solid ${colors.pureBlack};
    border-radius: 10px;
    padding: 10px;

    & > :not(:first-child) {
        margin-top: 20px;
        border-top: 1px solid ${colors.borderGrey};
    }
`;
